<template>
  <div class="app-container">
    <!-- 搜索区 -->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form" size="mini" style="width: 100%;">
        <div class="formItemBox">
          <el-form-item label="公司名称:">
            <el-select v-model="searchForm.companyName" placeholder="请选择/输入" clearable filterable allow-create default-first-option style="width:180px">
              <el-option v-for="item in companyList" :key="item.companyCode || item.itemNo || item.id" :label="item.companyName || item.showName" :value="item.companyName || item.showName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行名称:">
            <el-select v-model="searchForm.bankName" placeholder="请选择/输入" clearable filterable allow-create default-first-option style="width:220px">
              <el-option v-for="item in bankNameList" :key="item.itemNo" :label="item.showName" :value="item.showName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="担保人:">
            <el-select v-model="searchForm.securityUser" placeholder="请选择/输入" clearable filterable allow-create default-first-option style="width:180px">
              <el-option v-for="item in securityUserList" :key="item.itemNo" :label="item.showName" :value="item.showName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="法人:">
            <el-select v-model="searchForm.legalPerson" placeholder="请选择/输入" clearable filterable allow-create default-first-option style="width:180px">
              <el-option v-for="item in legalPersonList" :key="item.itemNo" :label="item.showName" :value="item.showName"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchBtnBox"  style="margin: 0;display: flex;align-items: center;">
          <el-form-item>
            <el-button type="primary" class="allBtn" v-if="btnFlg[0]" @click="searchFn">查询</el-button>
            <el-button type="primary" class="allBtn" @click="resetForm">重置</el-button>
            <el-button type="primary" class="allBtn" v-if="btnFlg[1]" @click="addFn">新增</el-button>
            <el-button type="primary" class="allBtn" v-if="btnFlg[2]" @click="exportFn">导出</el-button>
          </el-form-item>
            <!-- 汇总概要 -->
          <div class="sumBox">
            授信金额合计：<span>{{ summaryTop.creditAmount }}</span> 万元， 贷款金额合计：<span>{{ summaryTop.loanAmount }}</span> 万元， 未用授信金额合计：<span>{{ summaryTop.unUseAmount }}</span> 万元， 已还贷款金额合计：<span>{{ summaryTop.repaidAmount }}</span> 万元， 未还贷款金额合计：<span>{{ summaryTop.unRepayAmount }}</span> 万元
          </div>
        </div>
      </el-form>
    </div>
      <!-- 汇总概要 -->
    <div class="sumBox">
      信用贷款余额：<span>{{ summarySub.creditBalance }}</span> 万元， 占比：<span>{{ summarySub.creditRatio }}</span>， 两年期及以上贷款余额：<span>{{ summarySub.twoYearBalance }}</span> 万元， 占比：<span>{{ summarySub.twoYearRatio }}</span>
    </div>

    <!-- 表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" height="100%" class="tableComent" border highlight-current-row v-loading="loading" :span-method="arraySpanMethod" :cell-style="cellStyle">
        <el-table-column type="index" width="55" label="序号" fixed="left"></el-table-column>
        <el-table-column label="操作" width="240" fixed>
          <template slot-scope="scope">
            <el-button type="text" size="mini" v-if="btnFlg[3]" @click="editFn(scope.row)">修改</el-button>
            <el-button type="text" size="mini" v-if="btnFlg[4]&&scope.row.backAmount<=0" @click="delFn(scope.row)">删除</el-button>
            <el-button type="text" size="mini" v-if="btnFlg[5]" @click="detailFn(scope.row)">详情</el-button>
            <el-button type="text" size="mini" v-if="btnFlg[6]" @click="showMaterial(scope.row)">资料</el-button>
            <el-button type="text" size="mini" v-if="btnFlg[7]" @click="showInterest(scope.row)">利息</el-button>
            <el-button type="text" size="mini" v-if="btnFlg[8]" @click="showRepay(scope.row)">还款</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="loanNo" label="贷款编码" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyName" label="公司" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bankName" label="银行名称" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="putDate" label="放款日期" width="120" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="backDate" label="还款日期" width="120" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="creditAmount" label="授信金额(万元)" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="loanAmount" label="贷款金额(万元)" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="backAmount" label="已还金额(万元)" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="loanRate" label="利率" width="90">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showRateRecord(scope.row)">{{ rateFormat(scope.row, null, scope.row.loanRate) }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="loanRateEffectiveDate" label="利率生效日期" width="120" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="creditExpireDate" label="授信到期日" width="120" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="creditRemainAmount" label="未用金额(万元)" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column prop="securityTypeName" label="担保方式" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="securityUser" label="担保人" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="isCreditName" label="是否上征信" width="100"></el-table-column>
        <el-table-column prop="loanLife" label="贷款年限" width="90"></el-table-column>
        <el-table-column prop="creditLife" label="授信年限" width="90"></el-table-column>
        <el-table-column prop="hockLife" label="抵押年限" width="90"></el-table-column>
        <el-table-column prop="creditMode" label="授信方式" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="loanPlan" label="贷款方案" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="backInterestDateName" label="还贷款利息日期" width="200"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="legalPerson" label="法人" width="100" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.pageNo"
        :page-sizes="[10, 20, 25, 50, 100]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增/修改/详情 弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" center width="900px" @close="closeDialog">
      <el-form :model="addForm" :rules="rules" ref="addForm" :inline="false" size="small" label-width="120px" class="demo-form-inline loan-form" :disabled="isDetail">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="选择银行授信:" prop="creditInfoId">
              <el-select v-model="addForm.creditId" placeholder="请选择银行授信" clearable filterable style="width:100%" :disabled="isDetail" @change="selectCreditChange">
                <el-option v-for="item in creditInfoOptions" :key="item.id" :label="item.companyName + '-' + item.bankName + ' - 授信金额（' + item.creditAmount + '万元）'" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">授信信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公司名称:">
              <el-input v-model="addForm.companyName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行名称:">
              <el-input v-model="addForm.bankName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授信金额(万元):">
              <el-input v-model="addForm.creditAmount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授信到期日:">
              <el-input v-model="addForm.creditExpireDate" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">贷款信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="放款日期:" prop="putDate">
              <el-date-picker v-model="addForm.putDate" type="date" format="yyyy-MM-dd"   value-format="yyyy-MM-dd"  placeholder="请选择" style="width:100%" :disabled="isEdit" @change="putDateChange"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="还款日期:" prop="backDate">
              <el-date-picker v-model="addForm.backDate" type="date" format="yyyy-MM-dd"  value-format="yyyy-MM-dd"  placeholder="请选择" style="width:100%" :disabled="isEdit"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="贷款金额(万元):" prop="loanAmount">
              <el-input-number v-model="addForm.loanAmount" placeholder="请输入" :min="0" :precision="2" :step="100" controls-position="right" :disabled="isDetail || isEdit" style="width:100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="利率:" prop="loanRate">
              <el-input v-model="addForm.loanRate" placeholder="如1表示1%" style="width:100%">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="利率生效日期:" prop="loanRateEffectiveDate">
              <el-date-picker v-model="addForm.loanRateEffectiveDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择" style="width:100%" :disabled="!isEdit"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="还贷款利息日期:" prop="backInterestDate">
              <el-select v-model="addForm.backInterestDate" placeholder="请选择" clearable filterable style="width:100%" :disabled="isEdit">
                <el-option label="每月20日还贷款利息" value="A"></el-option>
                <el-option label="每月21日还贷款利息" value="B"></el-option>
                <el-option label="每季度20日还贷款利息" value="C"></el-option>
                <el-option label="每季度21日还贷款利息" value="D"></el-option>
                <el-option label="放贷时一次性还贷款利息" value="E"></el-option>
                <el-option label="每月25日固定向贷款账户打款还本金及利息" value="F"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="贷款方案:" prop="loanPlan">
              <el-input v-model="addForm.loanPlan" placeholder="请输入贷款方案" style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="借款合同:">
              <uploadFiles v-if="!isDetail" :fileArr.sync="imgList" :max="10" @remove="remove"></uploadFiles>
              <div v-else>
                <a v-for="(f,idx) in imgList" :key="idx" :href="f.url" target="_blank" style="margin-right:15px">{{ f.name || ('附件' + (idx+1)) }}</a>
                <span v-if="!imgList.length">无</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="!isDetail" type="primary" size="mini" :loading="saveLoading" @click="saveFn">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 资料（贷款资料）弹框 -->
    <el-dialog title="贷款资料" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="creditFileFlag" width="320px" center>
      <div class="fujianBox">
        <el-button type="text" v-for="item in creditFileList" :key="item.name" @click="creditFileClick(item)">{{ item.name }}</el-button>
      </div>
    </el-dialog>
    <!-- 查看图片弹框 -->
    <el-dialog title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="lookImgFlag" append-to-body width="800px" center>
      <div style="text-align:center;">
        <el-image style="width:100%;" :src="imgUrl" fit="contain"></el-image>
      </div>
    </el-dialog>

    <!-- 利息明细 弹框 -->
    <el-dialog title="贷款利息明细" :visible.sync="interestVisible" :close-on-click-modal="false" :close-on-press-escape="false" center width="1250px" @close="interestVisible=false">
      <div class="summary-line">
        <span>利息合计：<span class="num">{{ interestSummary.total }}</span> 万元，</span>
        <span>已还利息合计：<span class="num">{{ interestSummary.repaid }}</span> 万元，</span>
        <span>未还利息合计：<span class="num">{{ interestSummary.unRepaid }}</span> 万元</span>
      </div>
      <el-table :data="interestList" border height="380" v-loading="interestLoading">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 1" type="text" size="mini" @click="interestAdjust(scope.row)">调整</el-button>
            <!-- <el-button v-if="scope.row.status === 1" type="text" size="mini" @click="interestDel(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">{{ scope.row.status === 1 ? '已还' : '未还' }}</template>
        </el-table-column>
        <el-table-column prop="startDate" label="开始日期" width="100" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="endDate" label="结束日期" width="100" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="dayNum" label="天数" width="80"></el-table-column>
        <el-table-column prop="currAmount" label="当前本金(万元)" width="120"></el-table-column>
        <el-table-column prop="currRate" label="当前利率" width="100" :formatter="rateFormat"></el-table-column>
        <el-table-column prop="currInterestAmount" label="产生利息(万元)" width="120"></el-table-column>
        <el-table-column prop="backInterestDate" label="还息日期" width="100" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="actualInterestAmount" label="实际扣款金额(万元)" width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="actualInterestDate" label="实际扣款日期" width="100" :formatter="dateFormat"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="interestVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 利息调整弹框 -->
    <el-dialog title="调整" :visible.sync="interestAdjustVisible" :close-on-click-modal="false" :close-on-press-escape="false" center width="500px" append-to-body @close="closeInterestAdjust">
      <el-form :model="interestAdjustForm" size="small" label-width="150px" class="demo-form-inline">
        <el-form-item label="实际扣款金额(万元):">
            <el-input v-model="interestAdjustForm.actualInterestAmount" v-number-input.float="6" style="width:160px"></el-input>
        </el-form-item>
        <el-form-item label="实际扣款日期:">
          <el-date-picker v-model="interestAdjustForm.actualInterestDate" type="date" format="yyyy-MM-dd" value-format="timestamp" placeholder="请选择" style="width:160px"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="interestAdjustVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" :loading="interestAdjustLoading" @click="interestAdjustSubmit">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 还款 弹框 -->
    <el-dialog title="贷款本金明细" :visible.sync="repayVisible" :close-on-click-modal="false" :close-on-press-escape="false" center width="1150px" @close="repayVisible=false">
      <div class="summary-line">
        <span>贷款金额：<span class="num">{{ repaySummary.loanAmount }}</span> 万元，</span>
        <span>已还贷款金额合计：<span class="num">{{ repaySummary.repaid }}</span> 万元，</span>
        <span>未还贷款金额合计：<span class="num">{{ repaySummary.unRepaid }}</span> 万元，</span>
      </div>
      <el-divider content-position="left">还款</el-divider>
      <el-form :inline="true" size="small" class="demo-form">
        <el-form-item label="当前本金(万元):">
          <el-input v-model="repayForm.currentPrincipal" disabled style="width:140px"></el-input>
        </el-form-item>
        <el-form-item label="本次还款(万元):">
          <el-input v-model="repayForm.thisRepay" v-number-input.float="6" style="width:160px"></el-input>
        </el-form-item>
        <el-form-item label="剩余本金(万元):">
          <el-input :value="repayRemain" disabled style="width:140px"></el-input>
        </el-form-item>
        <el-form-item label="还款日期:">
          <el-date-picker v-model="repayForm.backDate" type="date" format="yyyy-MM-dd" value-format="timestamp" placeholder="请选择" style="width:140px"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="repaySubmit">还 款</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="repayList" border height="320" v-loading="repayLoading">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button v-if="scope.$index === 0" type="text" size="mini" @click="repayUndo(scope.row)">撤销</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="currAmount" label="当前本金(万元)" min-width="150"></el-table-column>
        <el-table-column prop="backAmount" label="还款金额(万元)" min-width="150"></el-table-column>
        <el-table-column prop="backDate" label="还款日期" min-width="150" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="remainAmount" label="剩余本金(万元)" min-width="120"></el-table-column>
        <el-table-column prop="createTime"  :formatter="dateTimeFormat" label="操作时间" width="160"></el-table-column>
        <el-table-column prop="createUser" label="操作人" min-width="100"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="repayVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 利率记录 弹框 -->
    <el-dialog title="利率记录" :visible.sync="rateRecordVisible" :close-on-click-modal="false" :close-on-press-escape="false" center width="900px" @close="rateRecordVisible=false">
      <el-table :data="rateRecordList" border height="380" v-loading="rateRecordLoading">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="type" label="类型" width="80"></el-table-column>
        <el-table-column prop="loanRateEffectiveDate" label="利率生效日期" width="120" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="newLoanRate" label="新利率" width="100">
          <template slot-scope="scope">{{ scope.row.newLoanRate != null ? Number(scope.row.newLoanRate).toFixed(2) + '%' : '-' }}</template>
        </el-table-column>
        <el-table-column prop="oldLoanRate" label="旧利率" width="100">
          <template slot-scope="scope">{{ scope.row.oldLoanRate != null ? Number(scope.row.oldLoanRate).toFixed(2) + '%' : '-' }}</template>
        </el-table-column>
        <el-table-column prop="createUser" label="创建人" min-width="100"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" :formatter="dateTimeFormat"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="rateRecordVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 导出字段配置 弹框 -->
    <el-dialog title="导出字段配置" :visible.sync="exportVisible" :close-on-click-modal="false" :close-on-press-escape="false" center width="500px" @close="exportVisible = false">
      <div class="export-check-wrap">
        <div class="export-check-head">
          <el-button type="primary" size="mini" @click="exportSelectAll">全 选</el-button>
          <el-button size="mini" @click="exportClearAll">取 消 全 选</el-button>
          <span class="export-check-tips">已选 {{ exportSelectedKeys.length }} / {{ exportColumns.length }}</span>
        </div>
        <el-checkbox-group v-model="exportSelectedKeys" class="export-check-group">
          <el-checkbox v-for="col in exportColumns" :label="col.key" :key="col.key">{{ col.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="exportVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" :loading="exportLoading" @click="exportSubmit">导 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDictionaryDetailList,
  loanInfoList,
  loanInfoAdd,
  loanInfoUpdate,
  loanInfoDelete,
  loanInfoDetail,
  loanInfoListTotal,
  findCreditInfoList,
  getUserCompanyDropDown,
  finLoanInterestList,
  findLoanBackList,
  loanBackRepayment,
  loanBackRepaymentRevoke,
  interestAdjustment,
  finLoanInterestDelete,
  loanRateRecordList
} from '@/api/common-signature'
import { dateFormat, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getBtn } from '@/utils/getButton'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import global from '@/api/global'

export default {
  name: 'LoanManage',
  components: { uploadFiles },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      searchForm: {
        pageNo: 1,
        pageSize: 50,
        companyName: '',
        bankName: '',
        securityUser: '',
        legalPerson: '',
        creditInfoId: ''
      },
      // 汇总（环境不通时先用 mock，接接口后由后端返回覆盖）
      summaryTop: { creditAmount: 0, loanAmount: 0, unUseAmount: 0, repaidAmount: 0, unRepayAmount: 0 },
      summarySub: { creditBalance: 0, creditRatio: '0%', twoYearBalance: 0, twoYearRatio: '0%' },
      tableList: [],
      total: 0,
      loading: false,
      // 字典
      companyList: [],
      bankNameList: [],
      securityTypeList: [],
      legalPersonList: [],
      securityUserList: [],
      termYearsList: [],
      loanPlanList: [],
      // 选择银行授信下拉（页面加载时由 findCreditInfoList 填充）
      creditInfoOptions: [],
      // 新增/修改/详情弹框
      dialogVisible: false,
      dialogTitle: '新增贷款',
      isDetail: false,
      isEdit: false,
      saveLoading: false,
      addForm: {},
      imgList: [],
      rules: {
        creditId: [{ required: true, message: '请选择银行授信', trigger: 'change' }],
        putDate: [{ required: true, message: '请选择放款日期', trigger: 'change' }],
        backDate: [{ required: true, message: '请选择还款日期', trigger: 'change' }],
        loanAmount: [
          { required: true, message: '请输入贷款金额', trigger: 'change' },
          { validator: (rule, value, cb) => { if (Number(value) > 0) cb(); else cb(new Error('贷款金额必须大于0')); }, trigger: 'change' }
        ],
        loanRate: [{ required: true, message: '请输入利率', trigger: 'blur' }],
        loanRateEffectiveDate: [{ required: true, message: '请选择利率生效日期', trigger: 'change' }],
        backInterestDate: [{ required: true, message: '请选择还贷款利息日期', trigger: 'change' }],
        loanPlan: [{ required: true, message: '请选择贷款方案', trigger: 'change' }]
      },
      h: '500px',
      // 利息弹框
      interestVisible: false,
      interestList: [],
      interestLoading: false,
      interestSummary: { total: 0, repaid: 0, unRepaid: 0 },
      // 利息调整弹框
      interestAdjustVisible: false,
      interestAdjustLoading: false,
      interestAdjustForm: { id: '', actualInterestAmount: null, actualInterestDate: '' },
      // 利率记录弹框
      rateRecordVisible: false,
      rateRecordList: [],
      rateRecordLoading: false,
      // 还款弹框
      repayVisible: false,
      repayLoading: false,
      repayForm: { currentPrincipal: 0, thisRepay: 0 },
      repayList: [],
      repaySummary: { loanAmount: 0, repaid: 0, unRepaid: 0 },
      // 当前操作行（详情/利息/还款共用）
      currentRow: null,
      // 资料（贷款资料）弹框
      creditFileList: [],
      creditFileFlag: false,
      lookImgFlag: false,
      imgUrl: '',
      // 合并单元格配置：按 creditId 合并的字段
      spanObj: {},
      // 导出字段配置弹框
      exportVisible: false,
      exportLoading: false,
      exportSelectedKeys: [],
      // 导出字段配置（与列表列一一对应，供用户勾选）
      exportColumns: [
        { name: '贷款编码', key: 'loanNo', width: 22, isWrap: true, type: 10 },
        { name: '公司', key: 'companyName', width: 22, isWrap: true, type: 10 },
        { name: '银行名称', key: 'bankName', width: 22, isWrap: true, type: 10 },
        { name: '放款日期', key: 'putDate', width: 14, isWrap: true, type: 10 },
        { name: '还款日期', key: 'backDate', width: 14, isWrap: true, type: 10 },
        { name: '授信金额', key: 'creditAmount', width: 13, isWrap: true, type: 10, 'mergeVertical': true, 'mergeRely': [0] },
        { name: '贷款金额', key: 'loanAmount', width: 13, isWrap: true, type: 10 },
        { name: '已还金额', key: 'backAmount', width: 13, isWrap: true, type: 10 },
        { name: '利率', key: 'loanRate', width: 10, isWrap: true, type: 10 },
        { name: '授信到期日', key: 'creditExpireDate', width: 14, isWrap: true, type: 10, 'mergeVertical': true, 'mergeRely': [0] },
        { name: '未用金额', key: 'creditRemainAmount', width: 13, isWrap: true, type: 10, 'mergeVertical': true, 'mergeRely': [0] },
        { name: '担保方式', key: 'securityTypeName', width: 12, isWrap: true, type: 10, 'mergeVertical': true, 'mergeRely': [0] },
        { name: '担保人', key: 'securityUser', width: 12, isWrap: true, type: 10, 'mergeVertical': true, 'mergeRely': [0] },
        { name: '是否上征信', key: 'isCreditName', width: 12, isWrap: true, type: 10, 'mergeVertical': true, 'mergeRely': [0] },
        { name: '贷款年限', key: 'loanLife', width: 11, isWrap: true, type: 10 },
        { name: '授信年限', key: 'creditLife', width: 11, isWrap: true, type: 10, 'mergeVertical': true, 'mergeRely': [0] },
        { name: '抵押年限', key: 'hockLife', width: 11, isWrap: true, type: 10, 'mergeVertical': true, 'mergeRely': [0] },
        { name: '授信方式', key: 'creditMode', width: 16, isWrap: true, type: 10, 'mergeVertical': true, 'mergeRely': [0] },
        { name: '贷款方案', key: 'loanPlan', width: 20, isWrap: true, type: 10 },
        { name: '还贷款利息日期', key: 'backInterestDateName', width: 20, isWrap: true, type: 10 },
        { name: '法人', key: 'legalPerson', width: 12, isWrap: true, type: 10 }
      ],
      btnFlg: [],
      btnIdArr: ['00FM190100', '00FM190200', '00FM190300', '00FM190400', '00FM190500', '00FM190600', '00FM190700', '00FM190800', '00FM190900']
    }
  },
  computed: {
    repayRemain () {
      const cur = Number(this.repayForm.currentPrincipal) || 0
      const rep = Number(this.repayForm.thisRepay) || 0
      return (cur - rep).toFixed(2)
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/loanManage')
    // 银行授信页「贷款明细」跳转携带的授信 id，进入后按该授信过滤
    const creditId = this.$route.query.creditId
    if (creditId) this.searchForm.creditInfoId = creditId
    this.getDictList()
    this.getCreditInfoOptions()
    this.getList()
  },
  mounted () {
    const topH = this.$refs.searchBox ? this.$refs.searchBox.offsetHeight : 120
    const pH = document.documentElement.clientHeight
    this.h = Math.max(pH - topH - 215, 200) + 'px'
  },
  methods: {
    /* ============ 字典 ============ */
    getDictList () {
      const map = [
        ['bankNameList', 'bank_name'],
        ['securityTypeList', 'security_type'],
        ['legalPersonList', 'legal_person'],
        ['securityUserList', 'security_user'],
        ['termYearsList', 'term_years'],
        ['loanPlanList', 'loan_plan']
      ]
      map.forEach(arr => {
        const key = arr[0]; const groupNo = arr[1]
        getDictionaryDetailList({ dictionaryType: groupNo }).then(res => {
          this[key] = Array.isArray(res) ? res : []
        }).catch(() => { this[key] = [] })
      })
      // 公司下拉改用 companySetting/getUserCompanyDropDown，返回 { data: [{companyCode, companyName}] }
      getUserCompanyDropDown().then(res => {
        this.companyList = res || []
      }).catch(e => { this.companyList = []; this._showError(e, '加载公司下拉失败') })
    },
    /* ============ 列表 ============ */
    getList () {
      this.loading = true
      this.getSummary()
      return loanInfoList(this.searchForm).then(res => {
        this.loading = false
        this.tableList = res.list
        // 只处理一列：是否上征信 0/1 → 显示名
        this.tableList.forEach(it => {
          if (it.isCredit !== '' && it.isCredit != null && (!it.isCreditName)) it.isCreditName = (Number(it.isCredit) === 1 ? '上' : '不上')
        })
        this.total = res.total
        this.computeSpan()
      }).catch(err => {
        this.loading = false
        this._showError(err, '获取贷款列表失败')
      })
    },
    // 统计查询（授信/贷款合计、信用与两年期占比），取数聚合于后端
    getSummary () {
      loanInfoListTotal(this.searchForm).then(res => {
        const mapTotal = res.mapTotal || (res.data && res.data.mapTotal) || {}
        const mapMix = res.mapMix || (res.data && res.data.mapMix) || {}
        this.summaryTop = {
          creditAmount: mapTotal.creditAmountTotal || 0,
          loanAmount: mapTotal.loanAmountTotal || 0,
          unUseAmount: mapTotal.remainCreditAmountTotal || 0,
          repaidAmount: mapTotal.backLoanAmountTotal || 0,
          unRepayAmount: mapTotal.remainLoanAmountTotal || 0
        }
        this.summarySub = {
          creditBalance: mapMix.xinyongTotal || 0,
          creditRatio: this.fmtRate(mapMix.xinyongTotalRate),
          twoYearBalance: mapMix.twoYearTotal || 0,
          twoYearRatio: this.fmtRate(mapMix.twoYearTotalRate)
        }
      }).catch(() => {})
    },
    // 占比统一加 %（兼容后端返回带 % 或不带 % 两种）
    fmtRate (v) {
      if (v === '' || v == null) return '0%'
      let s = String(v)
      if (s.indexOf('%') === -1) s = s + '%'
      return s
    },
    searchFn () {
      this.searchForm.pageNo = 1
      this.getList()
    },
    resetForm () {
      this.searchForm = { pageNo: 1, pageSize: 50, companyName: '', bankName: '', securityUser: '', legalPerson: '', creditInfoId: '' }
      this.getList()
    },
    // 打开导出字段配置弹框（默认全选）
    exportFn () {
      this.exportSelectedKeys = this.exportColumns.map(c => c.key)
      this.exportVisible = true
    },
    exportSelectAll () {
      this.exportSelectedKeys = this.exportColumns.map(c => c.key)
    },
    exportClearAll () {
      this.exportSelectedKeys = []
    },
    exportSubmit () {
      if (!this.exportSelectedKeys || this.exportSelectedKeys.length === 0) {
        this.$message.warning('请至少选择一个导出字段')
        return
      }
      this.exportLoading = true
      const header = this.exportColumns
        .filter(c => this.exportSelectedKeys.indexOf(c.key) > -1)
        .map(c => ({ name: c.name, key: c.key, width: c.width, isWrap: c.isWrap, type: c.type, mergeVertical: c.mergeVertical, mergeRely: c.mergeRely }))
      header.unshift({ name: '授信id', key: 'creditId', width: 22, isWrap: true, type: 10, isColumnHidden: true })
      const params = Object.assign({}, this.searchForm, { header })
      const url = global.smpName + '/loanInfo/exportList'
      exportExcel(url, params, '贷款管理').then(() => {
        this.exportLoading = false
        this.exportVisible = false
        this.$message.success('导出成功')
      }).catch(err => {
        this.exportLoading = false
        this._showError(err, '导出失败')
      })
    },
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.getList()
    },
    sumNum (data, key) {
      if (!Array.isArray(data)) return 0
      return data.reduce((s, r) => s + (Number(r[key]) || 0), 0)
    },
    // 按 creditId 分组计算需要合并单元格的字段（连续相同 creditId 的行合并）
    computeSpan () {
      const props = [
        'creditAmount', 'creditExpireDate', 'creditRemainAmount', 'securityTypeName',
        'securityUser', 'isCreditName', 'creditLife', 'hockLife', 'legalPerson', 'creditMode'
      ]
      const data = this.tableList || []
      const mergeId = 'creditId'
      const spanObj = {}
      props.forEach(p => {
        const arr = []
        let pos = 0
        for (let i = 0; i < data.length; i++) {
          if (i === 0) {
            arr.push(1)
            pos = 0
          } else {
            const cur = data[i][mergeId]
            const pre = data[i - 1][mergeId]
            if (cur != null && cur !== '' && cur === pre) {
              arr[pos] += 1
              arr.push(0)
            } else {
              arr.push(1)
              pos = i
            }
          }
        }
        spanObj[p] = arr
      })
      this.spanObj = spanObj
    },
    // el-table 单元格合并回调
    arraySpanMethod ({ column, rowIndex }) {
      const prop = column.property
      if (this.spanObj[prop]) {
        const rowspan = this.spanObj[prop][rowIndex]
        if (rowspan > 0) return { rowspan: rowspan, colspan: 1 }
        return { rowspan: 0, colspan: 0 }
      }
      return { rowspan: 1, colspan: 1 }
    },
    // 还款日期预警：isWarning 为 1（是）时，还款日期单元格背景标淡红（参考 vgs-driver2.0 司机页 getCellStyle）
    cellStyle ({ row, column }) {
      if (column.property === 'backDate' && (row.isWarning === 1 || row.isWarning === '1')) {
        return { background: '#FEB0A4' }
      }
      return {}
    },
    rateFormat (row, col, val) {
      if (val === '' || val == null) return ''
      return Number(val).toFixed(2) + '%'
    },
    /* ============ 新增/修改/详情 ============ */
    resetAddDialog () {
      this.addForm = {
        creditId: '',
        companyName: '',
        bankName: '',
        creditAmount: '',
        creditExpireDate: '',
        putDate: '',
        backDate: '',
        loanAmount: '',
        loanRate: '',
        loanRateEffectiveDate: '',
        loanLife: '',
        backInterestDate: '',
        loanPlan: '',
        id: '',
        fileDeleteIds: []
      }
      this.imgList = []
    },
    // 新增时利率生效日期跟随放款日期，不可单独修改；修改时可单独改
    putDateChange (val) {
      if (!this.isEdit) {
        this.addForm.loanRateEffectiveDate = val
      }
    },
    addFn () {
      this.isEdit = false
      this.isDetail = false
      this.dialogTitle = '新增贷款'
      this.dialogVisible = true
      this.resetAddDialog()
      this.$nextTick(() => { this.$refs.addForm && this.$refs.addForm.clearValidate() })
    },
    editFn (row) {
      this.isEdit = true
      this.isDetail = false
      this.dialogTitle = '修改贷款'
      this.dialogVisible = true
      this.currentRow = row
      this.fillAddForm(row)
      this.loadLoanFiles(row.id)
    },
    detailFn (row) {
      this.isEdit = false
      this.isDetail = true
      this.dialogTitle = '贷款详情'
      this.dialogVisible = true
      this.currentRow = row
      this.fillAddForm(row)
      this.loadLoanFiles(row.id)
    },
    // 表单值/展示字段仍用原方法：列表行 + 授信下拉回查；不依赖详情接口
    fillAddForm (row) {
      this.resetAddDialog()
      this.addForm = Object.assign({}, this.addForm, row)
      // 回显关联授信：兼容后端返回 creditId / creditInfoId
      this.addForm.creditId = row.creditId != null ? row.creditId : (row.creditInfoId != null ? row.creditInfoId : '')
      // 授信信息展示字段（公司/银行/授信金额/授信到期日）按 creditId 回查填充
      const hit = (this.creditInfoOptions || []).find(i => i.id === this.addForm.creditId)
      if (hit) {
        this.addForm.companyName = hit.companyName
        this.addForm.bankName = hit.bankName
        this.addForm.creditAmount = hit.creditAmount
        this.addForm.creditExpireDate = (hit.creditExpireDate != null && hit.creditExpireDate !== '')
          ? dateFormat(null, null, hit.creditExpireDate)
          : ''
      }
      this.imgList = []
    },
    // 仅从 loanInfo/detail 取附件回填 imgList（不影响表单其余字段）
    loadLoanFiles (id) {
      if (id == null) return
      var vm = this
      loanInfoDetail({ id }).then(function (res) {
        vm.imgList = (res.files || []).map(function (f) {
          return {
            status: 'ready',
            url: f.fileKeyUrl,
            id: f.id,
            name: f.filePath ? f.filePath.split('/').pop() : (f.name || '未命名文件')
          }
        })
      }).catch(function () { vm.imgList = [] })
    },
    // 选择银行授信 -> 回显授信信息
    selectCreditChange (val) {
      const hit = (this.creditInfoOptions || []).find(i => i.id === val)
      if (!hit) return
      this.addForm.companyName = hit.companyName
      this.addForm.bankName = hit.bankName
      this.addForm.creditAmount = hit.creditAmount
      this.addForm.creditExpireDate = (hit.creditExpireDate != null && hit.creditExpireDate !== '')
        ? dateFormat(null, null, hit.creditExpireDate)
        : ''
    },
    saveFn () {
      var vm = this
      if (!vm.$refs.addForm) return
      vm.$refs.addForm.validate(function (valid) {
        if (!valid) { vm.$message.warning('请检查表单必填项'); return }
        // 字段名已对齐 FinLoanInfo 实体，直接浅拷贝直传（参考银行授信 saveFn）
        var f = Object.assign({}, vm.addForm)
        // 删除的附件 id 放进 params（remove 方法维护），格式 [{"id":xx}]（参考银行授信 deleteFileIds）
        if (!Array.isArray(f.fileDeleteIds)) f.fileDeleteIds = []
        var isUpdate = !!(f.id && vm.isEdit)
        var files = (vm.imgList || []).filter(function (x) { return x && x.raw })
        var apiFn = isUpdate ? loanInfoUpdate : loanInfoAdd
        var loading = vm.$loading({ lock: true, text: '保存中...' })
        // 始终用 FormData：params=JSON，files=新附件（参考银行授信 saveFn）
        var fd = new FormData()
        fd.set('params', JSON.stringify(f))
        files.forEach(function (x) { fd.append('files', x.raw, x.name || (x.raw && x.raw.name) || 'file') })
        var done = function () {
          loading.close()
          vm.$message.success(isUpdate ? '修改成功' : '新增成功')
          vm.dialogVisible = false
          vm.getList()
        }
        var fail = function (err) {
          loading.close()
          vm._showError(err, isUpdate ? '修改贷款失败' : '新增贷款失败')
        }
        apiFn(fd).then(done).catch(fail)
      })
    },
    delFn (row) {
      var _this = this
      _this.$confirm('是否删除此贷款记录？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        var loading = _this.$loading({ lock: true, text: '删除中...' })
        loanInfoDelete({ id: row.id })
          .then(function () {
            loading.close()
            _this.$message.success('删除成功')
            _this.getList()
          })
          .catch(function (err) {
            loading.close()
            _this._showError(err, '删除贷款失败')
          })
      }).catch(function () {})
    },
    showMaterial (row) {
      var vm = this
      var loading = this.$loading({ lock: true, text: '加载中...' })
      loanInfoDetail({ id: row.id }).then(function (res) {
        loading.close()
        var files = (res.files || []).map(function (f) {
          return {
            name: f.filePath ? f.filePath.split('/').pop() : (f.name || '未命名文件'),
            url: f.fileKeyUrl
          }
        })
        if (files.length === 0) {
          vm.$alert('暂无可查看的贷款资料', '系统提示')
        } else {
          vm.creditFileList = files
          vm.creditFileFlag = true
        }
      }).catch(function (err) {
        loading.close()
        vm._showError(err, '获取贷款资料失败')
      })
    },
    creditFileClick (item) {
      if (this.isImage(item.name)) {
        this.imgUrl = item.url
        this.lookImgFlag = true
      } else {
        window.open(item.url)
      }
    },
    isImage (name) {
      if (!name) return false
      return /\.(png|jpe?g|gif|bmp|webp)$/i.test(name)
    },
    closeDialog () {
      this.addForm = {}
      this.imgList = []
    },
    remove (file) {
      // uploadFiles 删除回调：组件仅 emit 被删的 file，剩余文件由 :fileArr.sync 自动同步（勿手动置空 imgList）
      // 删除附件 id 收集进 fileDeleteIds，格式与银行授信 deleteFileIds 一致：[id1, id2]（数组元素为纯 id）
      if (file && file.id != null && file.id !== '') {
        if (!this.addForm.fileDeleteIds) this.addForm.fileDeleteIds = []
        if (this.addForm.fileDeleteIds.indexOf(file.id) === -1) this.addForm.fileDeleteIds.push(file.id)
      }
    },
    /* ============ 利息弹框 ============ */
    // 列表接口通用取数：兼容 {list:{list:[...]}} / {list:[...]} / [...] 三种结构
    pickList (res) {
      const d = res || {}
      const inner = d.list || {}
      return Array.isArray(inner.list) ? inner.list
        : (Array.isArray(d.list) ? d.list : (Array.isArray(d) ? d : []))
    },
    showInterest (row) {
      this.currentRow = row
      this.interestVisible = true
      this.interestLoading = true
      finLoanInterestList({ creditId: row.creditId, loanId: row.id }).then(res => {
        this.interestLoading = false
        const d = res || {}
        const wrap = (d.list && typeof d.list === 'object') ? d.list : d
        this.interestList = this.pickList(res)
        // 顶部统计：取后端返回的利息汇总字段（与列表同响应体，兼容在 list 包装内/外两种情况）
        this.interestSummary = {
          total: d.currInterestAmountAll || wrap.currInterestAmountAll || 0,
          repaid: d.currInterestAmountYhAll || wrap.currInterestAmountYhAll || 0,
          unRepaid: d.currInterestAmountWhAll || wrap.currInterestAmountWhAll || 0
        }
      }).catch(err => {
        this.interestLoading = false
        this._showError(err, '获取贷款利息明细失败')
      })
    },
    // 利率记录弹框：分页写死第一页500条，页面不带分页
    showRateRecord (row) {
      this.rateRecordVisible = true
      this.rateRecordLoading = true
      this.rateRecordList = []
      loanRateRecordList({ id: row.id, pageNo: 1, pageSize: 500 }).then(res => {
        this.rateRecordLoading = false
        this.rateRecordList = this.pickList(res)
      }).catch(err => {
        this.rateRecordLoading = false
        this._showError(err, '获取利率记录失败')
      })
    },
    interestAdjust (row) {
      this.interestAdjustForm = {
        id: row.id,
        actualInterestAmount: row.actualInterestAmount != null ? row.actualInterestAmount : null,
        actualInterestDate: row.actualInterestDate || ''
      }
      this.interestAdjustVisible = true
    },
    closeInterestAdjust () {
      this.interestAdjustForm = { id: '', actualInterestAmount: null, actualInterestDate: '' }
    },
    interestAdjustSubmit () {
      const f = this.interestAdjustForm
      if (Number(f.actualInterestAmount) <= 0) { this.$message.warning('实际扣款金额必须大于0'); return }
      this.interestAdjustLoading = true
      interestAdjustment({
        id: f.id,
        actualInterestAmount: f.actualInterestAmount,
        actualInterestDate: f.actualInterestDate
      }).then(() => {
        this.interestAdjustLoading = false
        this.interestAdjustVisible = false
        this.$message.success('利息调整成功')
        this.showInterest(this.currentRow)
      }).catch(err => {
        this.interestAdjustLoading = false
        this._showError(err, '利息调整失败')
      })
    },
    interestDel (row) {
      const _this = this
      _this.$confirm('是否删除此利息记录？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        const loading = _this.$loading({ lock: true, text: '删除中...' })
        finLoanInterestDelete({ id: row.id }).then(function () {
          loading.close()
          _this.$message.success('删除成功')
          // 同步本地列表 + 重新拉取后端数据（确保与数据库一致）
          _this.interestList = _this.interestList.filter(i => i.id !== row.id)
          _this.showInterest(_this.currentRow)
        }).catch(function (err) {
          loading.close()
          _this._showError(err, '删除利息失败')
        })
      }).catch(function () {})
    },
    /* ============ 还款弹框 ============ */
    showRepay (row) {
      this.currentRow = row
      this.repayVisible = true
      this.repayLoading = true
      const riqi = new Date()
      riqi.setHours(0, 0, 0, 0)
      this.repayForm = {
        currentPrincipal: (Number(row.loanAmount) || 0) - (Number(row.backAmount) || 0),
        thisRepay: 0,
        backDate: riqi.getTime() // 还款日期：当前日期时间戳
      }

      findLoanBackList({ creditId: row.creditId, loanId: row.id }).then(res => {
        this.repayLoading = false
        const d = res || {}
        this.repayList = this.pickList(res)
        // 顶部统计：取后端返回的本金汇总字段（与列表同响应体，兼容在 list 包装内/外两种情况）
        this.repaySummary = {
          loanAmount: d.loanAmount || 0,
          repaid: d.loanBackAmount || 0,
          unRepaid: d.loanRemainAmount || 0
        }
      }).catch(err => {
        this.repayLoading = false
        this._showError(err, '获取贷款本金明细失败')
      })
    },
    repaySubmit () {
      if (Number(this.repayForm.thisRepay) <= 0) { this.$message.warning('请输入本次还款金额'); return }
      if (!this.repayForm.backDate) { this.$message.warning('请选择还款日期'); return }
      const cur = Number(this.repayForm.currentPrincipal) || 0 // 当前本金 = 主数据贷款金额 - 已还金额
      const back = Number(this.repayForm.thisRepay) || 0 // 本次还款金额
      const remain = cur - back // 剩余本金 = 当前本金 - 本次还款
      if (remain < 0) { this.$message.warning('本次还款金额不能超过当前本金'); return }
      const param = {
        loanId: this.currentRow.id,
        creditId: this.currentRow.creditId,
        currAmount: cur, // 当前本金
        backAmount: back, // 本次还款
        remainAmount: remain, // 剩余本金
        backDate: this.repayForm.backDate
      }
      loanBackRepayment(param).then(() => {
        this.$message.success('还款成功')
        var vm = this
        this.getList().then(function () {
          // 重新定位最新主数据行，使当前本金（贷款金额-已还金额）按最新值重算
          var fresh = vm.tableList.find(function (it) { return it.id === vm.currentRow.id })
          if (fresh) vm.currentRow = fresh
          vm.showRepay(vm.currentRow)
        })
      }).catch(err => this._showError(err, '还款失败'))
    },
    repayUndo (row) {
      var _this = this
      _this.$confirm('是否撤销该笔还款记录？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        loanBackRepaymentRevoke({ creditId: _this.currentRow.creditId, loanId: _this.currentRow.id, id: row.id }).then(function () {
          _this.$message.success('撤销成功')
          _this.getList().then(function () {
            var fresh = _this.tableList.find(function (it) { return it.id === _this.currentRow.id })
            if (fresh) _this.currentRow = fresh
            _this.showRepay(_this.currentRow)
          })
        }).catch(function (err) {
          _this._showError(err, '撤销还款失败')
        })
      }).catch(function () {})
    },
    /* ============ 银行授信下拉 ============ */
    // 选择银行授信：取银行授信列表（后端需 pageNo/pageSize，这里拉全部；下拉本身无分页 UI）
    getCreditInfoOptions () {
      findCreditInfoList({ pageNo: 1, pageSize: 9999 }).then(res => {
        const d = res || {}
        const inner = d.list || {}
        const list = Array.isArray(inner.list) ? inner.list
          : (Array.isArray(d.list) ? d.list : [])
        this.creditInfoOptions = Array.isArray(list) ? list : []
      }).catch(() => { this.creditInfoOptions = [] })
    },
    // 统一错误提示
    _showError (err, msg) {
      var m = msg
      if (err) {
        if (err.msg) m = err.msg
        else if (err.message) m = err.message
        else if (err.response && err.response.data && err.response.data.msg) m = err.response.data.msg
      }
      this.$message.error(m)
    }
  }
}
</script>

<style scoped lang="less">
.searchBtnBox {
  margin-left: 10px;
}
.sumBox {
  padding: 10px 0;
  font-size: 14px;
  color: #333;
  span {
    color: #F56C6C;
    font-weight: bold;
    font-size: 14px;
  }
  & + .sumBox {
    margin-top: 6px;
  }
}
.pagination {
  margin-top: 10px;
  text-align: left;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
.loan-form {
  // 修改弹框中禁用的字段，加深文字颜色，避免太灰看不清
  /deep/ .el-input.is-disabled .el-input__inner,
  /deep/ .el-textarea.is-disabled .el-textarea__inner,
  /deep/ .el-range-editor.is-disabled input {
    color: #606266;
    -webkit-text-fill-color: #606266;
  }
  .el-row {
    display: flex;
    flex-wrap: wrap;
  }
}
.summary-line {
  margin-bottom: 10px;
  font-size: 14px;
  color: #333;
  span { color: #333; }
  .num {
    color: #F56C6C;
    font-weight: bold;
  }
}
.fujianBox {
  max-height: 320px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .el-button {
    margin-left: 0;
  }
}
.export-check-wrap {
  max-height: 360px;
  overflow-y: auto;
  .export-check-head {
    margin-bottom: 12px;
    .export-check-tips {
      margin-left: 12px;
      font-size: 12px;
      color: #999;
    }
  }
  .export-check-group {
    .el-checkbox {
      width: 30%;
      margin-right: 0;
      margin-bottom: 10px;
      color: #333;
    }
  }
}
</style>
